import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { errores } from '../../hooks/Funciones'
import EmojiPicker from 'emoji-picker-react';
import { MDBBtn, MDBModal, MDBModalBody, MDBModalFooter, MDBModalHeader } from 'mdbreact';

function validarNumeroTelefonico(numero) {
	// Verificamos que el número de teléfono comience con '+' seguido de uno o más dígitos
	const indicativoRegex = /^\+\d{2}/;

	// Verificamos si el número cumple con el formato del indicativo
	if (!indicativoRegex.test(numero)) {
		console.log("No cumple con el formato del indicativo.");
		return false;
	}

	// Extraemos el indicativo
	const indicativo = numero.match(indicativoRegex)[0];
	console.log("Indicativo:", indicativo);

	// Verificamos que el resto del número después del indicativo tenga solo dígitos
	const restoNumero = numero.replace(indicativo, '');
	console.log("Resto del número:", restoNumero);

	if (!restoNumero.trim() || !/^\d+$/.test(restoNumero.trim())) {
		console.log("El resto del número no contiene solo dígitos.");
		return false;
	}

	return true;
}

const SubirEstados = ({ baseUrl, setFuncion, funcion, registroSelect, peticionTraeDatos, estados, urlCampanas }) => {
	//errores

	const [error, setError] = useState({ activo: '' })
	const [clientes, setClientes] = useState([])
	const [clientesSeleccionados, setClientesSeleccionados] = useState([])
	const [registro, setRegistro] = useState(
		funcion === 'editar' ?
			{ ...registroSelect } :
			{ cursos: [] }
	)
	const [inputStr, setInputStr] = useState("");
	const [showPicker, setShowPicker] = useState(false);
	const [clientesRespaldo, setClientesRespaldo] = useState([])
	const [modal, setModal] = useState(false)
	const [cursos, setCursos] = useState([])

	const peticionTraeClientes = async () => {
		axios.get(baseUrl, { params: { usuario: '1', clave: '1', unico: 'false' } })
			.then(response => {
				setClientes(response.data)
				setClientesRespaldo(response.data)
			}).catch(error => {
				console.log(error)
			})

		const urlCursos = process.env.REACT_APP_BASE_URL + process.env.REACT_APP_API + 'cursos/'
		axios.get(urlCursos)
			.then(response => {
				setCursos(response.data)
			}).catch(error => {
				console.log(error)
			})
	}

	useEffect(() => {
		peticionTraeClientes()
	}, [])

	//Consulta para subir o crear los datos 
	const validarModal = () => {
		for (let i = 0; i < clientesSeleccionados.length; i++) {

			if (!validarNumeroTelefonico(clientesSeleccionados[i].telefono)) {
				alert(`El número de teléfono ${clientesSeleccionados[i].telefono} no es válido`)
				return errores('Telefono', setError, `El número de teléfono ${clientesSeleccionados[i].telefono} no es válido`)
			}
		}

		if (inputStr !== "" && clientesSeleccionados.length !== 0) {
			setModal(true)
			errores('', setError)
		} else errores('CampoVacio', setError)
	}

	const peticionPost = () => {
		let formData = new FormData()
		formData.append('mensaje', inputStr)
		formData.append('clientesSeleccionados', JSON.stringify(clientesSeleccionados))
		formData.append('METHOD', 'POST')

		axios.post(urlCampanas, formData)
			.then(response => {
				peticionTraeDatos()
				setFuncion('ver')
			}).catch(error => {
				console.log(error);
			})
	}
	const onEmojiClick = (emojiObject, event) => {
		setInputStr((prevInput) => prevInput + emojiObject.emoji);
		setShowPicker(false);
	};

	const validarSiEstaSeleccionadoTodo = () => clientes.length === clientesSeleccionados.length

	const seleccionarTodo = () => setClientesSeleccionados(clientes)

	const deseleccionarTodo = () => setClientesSeleccionados([])

	const buscarProductos = (item) => clientesSeleccionados.some(pro => item.id === pro.id)

	const seleccionarInput = (item) => {
		if (buscarProductos(item)) {
			const removerProducto = clientesSeleccionados.filter(pro => item.id != pro.id)
			setClientesSeleccionados(removerProducto)
		} else {
			setClientesSeleccionados([...clientesSeleccionados, item])
		}
	}
	const buscarporEstado = (e) => {
		if (e == "0") {
			return setClientes(clientesRespaldo)
		}
		setClientes(clientesRespaldo.filter(item => item.id_estado_crm == e))
	};
	const toggle = () => setModal(!modal)

	const seleccionarCursos = () => {

	}

	return (
		<div>
			<div className="row">
				<div className="col-md-12">
					{error.activo ?
						<span className="error"> Error: {error.mensaje}</span> : null
					}
					<div><hr />

						<div className='row '>
							<div className='col-md-12'>
								<label>Mensaje Masivo (Max 250 caracteres)</label>
								<div className="form-group campo-texto-mensaje">
									<textarea
										className="form-control text-area-mensaje"
										id="exampleFormControlTextarea1"
										rows="3"
										placeholder="Escribe un mensaje masivo"
										value={inputStr}
										onChange={(e) => setInputStr(e.target.value)}
									/>
									<img
										className="emoji-icon"
										src="https://icons.getbootstrap.com/assets/icons/emoji-smile.svg"
										onClick={() => setShowPicker((val) => !val)}
									/>
									{showPicker && (
										<EmojiPicker className="emoji-mensaje" onEmojiClick={onEmojiClick} />
									)}
								</div>

							</div>
							<div className='row col-12'>
								<div className='col-md-4'>
									<span>Seleccionar por estado:</span>
									<select className="browser-default custom-select selectEstado"
										style={{ marginBottom: 5 }}
										name="estado"
										id="estado"
										required
										value={registro.estado_crm}
										onChange={e => {
											const selectedIndex = e.target.selectedIndex;
											const selectedOption = e.target.options[selectedIndex];
											const estadoColor = selectedOption.getAttribute('data-color');
											const id = selectedOption.getAttribute('id');
											buscarporEstado(id)
										}}>
										<option value='0' id="0">Seleccione...</option>
										{estados?.map((item) => {
											return <option key={item.nombre} value={item.nombre} data-color={item.color} id={item.id}>{item.nombre}</option>
										})}
									</select>
								</div>
								<div className='col-md-4'>
									<span>Seleccionar por cursos de interes:</span>
									<select className="browser-default custom-select selectEstado"
										style={{ marginBottom: 5 }}
										name="cursos"
										id="cursos"
										required
										onChange={e => {
											const selectedIndex = e.target.selectedIndex;
											const selectedOption = e.target.options[selectedIndex];
											const estadoColor = selectedOption.getAttribute('data-color');
											const id = selectedOption.getAttribute('id');

											buscarporEstado(id)
										}}>
										<option value='0' id="0">Seleccione...</option>
										{cursos?.map((item) => {
											return <option key={item.nombre} value={item.nombre} id={item.id}>{item.nombre}</option>
										})}
									</select>
								</div>
							</div>
							<div className='col-md-12'>
								<h5>Seleccione Clientes para enviar Campaña:</h5>
								<div className='col-md-12 row' style={{ maxHeight: 600, overflowY: 'scroll' }}>
									{clientes.map((item, index) => {
										return (
											<div className="custom-control custom-checkbox custom-control-inline col-4" key={index}>
												<input type="checkbox" className="custom-control-input" name={item.id_curso} id={item.id}
													onChange={() => seleccionarInput(item)} checked={buscarProductos(item)} />
												<label className="custom-control-label" htmlFor={item.id}>{item.nombre} - {item.telefono}</label>
											</div>
										)
									})
									}
								</div>
							</div>
						</div>

						<br />
						<div className="col text-center">
							{validarSiEstaSeleccionadoTodo() ?
								<button
									type='button'
									onClick={deseleccionarTodo}
									className="btn boton_estandar"
								>Deseleccionar todo
								</button>
								:
								<button
									type='button'
									onClick={seleccionarTodo}
									className="btn boton_estandar"
								>Seleccionar todo
								</button>
							}
							<button
								type='button'
								onClick={validarModal}
								className="btn boton_estandar"
							>{`Crear Campaña`}
							</button>

						</div>

					</div>
				</div>
			</div>
			<MDBModal isOpen={modal} toggle={toggle}>
				<MDBModalHeader toggle={toggle}>Alerta</MDBModalHeader>
				<MDBModalBody>
					¿Desea realmente enviar la campaña a los {clientesSeleccionados.length} clientes seleccionados?
				</MDBModalBody>
				<MDBModalFooter>
					<button
						type='button'
						onClick={toggle}
						className="btn boton_estandar"
					>{`Cancelar`}
					</button>
					<button
						type='button'
						onClick={peticionPost}
						className="btn boton_estandar"
					>{`Enviar Campaña`}
					</button>
				</MDBModalFooter>
			</MDBModal>
		</div >
	)
}

export default SubirEstados